// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__rLlC8","tab":"Tabs_tab__3fSKI","tabActive":"Tabs_tabActive__3m6qx"};